import { siteData } from '@/mocks/siteData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-label mb-3">
            <i className="ri-focus-line"></i>焦点专题
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            本周焦点 · 深度策划
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            编辑精选的深度专题内容，带你全方位了解娱乐圈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {siteData.carousel.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group relative block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer no-underline lg:col-span-1"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-label px-2.5 py-1 rounded-full bg-primary-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-label">
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}